import ActionTypes from '../constants';

const initialState = {
    clients: {},
    client: {}
    // loading: false,
};

const clientReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETCLIENTSUCCESS:
            return {
                ...state,
                clients: action.payload,
            }
        case ActionTypes.GETCLIENTBYIDSUCCESS:
            return {
                ...state,
                client: action.payload,
            }
        default:
            return state;
    }
}

export default clientReducer;